import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Alert, Spinner, Badge } from 'react-bootstrap'
import DatumLayout from 'datum/layout'
import { useDatumReports } from 'api/hooks/use-datum-reports'

const reportTypeVariant = (type) => {
  const types = {
    PowerBIReport: 'badge-secondary',
    PaginatedReport: 'badge-info'
  }
  return types[type] || 'secondary'
}

const DatumReportsList = () => {
  const navigate = useNavigate()
  const { data: reports, isLoading, error } = useDatumReports()

  return (
    <DatumLayout title="Reports">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Reports</h4>
      </div>

      {isLoading && (
        <div className="text-center p-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading reports...</span>
          </Spinner>
        </div>
      )}

      {error && (
        <Alert variant="danger">
          Failed to load reports. Please try again later.
        </Alert>
      )}

      {!isLoading && !error && (
        <>
          {reports && reports.length > 0 ? (
            <Table hover responsive className="mb-0">
              <thead className="table-light">
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report) => (
                  <tr
                    key={report.id}
                    onClick={() => navigate(`/datum/reports/${report.id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="fw-medium">{report.name}</td>
                    <td>
                      <Badge bg="" className={reportTypeVariant(report.reportType)}>
                        {report.reportType || 'Report'}
                      </Badge>
                    </td>
                    <td className="text-muted">{report.description || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Alert variant="info" className="mb-0">
              No reports are available for your organization in Datum Insights.
            </Alert>
          )}
        </>
      )}
    </DatumLayout>
  )
}

export default DatumReportsList
